// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { getLogoutURLRequestToJson, getLogoutURLResponseFromJson, getSessionTransferURLRequestToJson, getSessionTransferURLResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function getSessionTransferURL(request) {
    const raw = await fetchRpc('sso.v1.ServiceProvider/GetSessionTransferURL', getSessionTransferURLRequestToJson(request));
    return getSessionTransferURLResponseFromJson(raw);
}
export function getSessionTransferURL$(request, options) {
    return defer(() => getSessionTransferURLWithTransport$(getGlobalTransport(), request, options));
}
export function getSessionTransferURLWithTransport$(transport, request, options) {
    return transport
        .post('sso.v1.ServiceProvider/GetSessionTransferURL', getSessionTransferURLRequestToJson(request), options)
        .pipe(map(resp => getSessionTransferURLResponseFromJson(resp)));
}
export async function getLogoutURL(request) {
    const raw = await fetchRpc('sso.v1.ServiceProvider/GetLogoutURL', getLogoutURLRequestToJson(request));
    return getLogoutURLResponseFromJson(raw);
}
export function getLogoutURL$(request, options) {
    return defer(() => getLogoutURLWithTransport$(getGlobalTransport(), request, options));
}
export function getLogoutURLWithTransport$(transport, request, options) {
    return transport
        .post('sso.v1.ServiceProvider/GetLogoutURL', getLogoutURLRequestToJson(request), options)
        .pipe(map(resp => getLogoutURLResponseFromJson(resp)));
}
